<template>
  <div id="admin-print">
      <div id="admin-print-container" v-for="(item,index) in products" :key="index">
        <div class="print-photo">
          <img v-bind:src="item.imageUrl" alt="item">
        </div>
        <div class="print-text">
          <div>訂單號碼 : {{item.orderId}}</div>
          <div>訂購人：{{item.recipient}}</div>
          <div>寄送地址：{{item.address}}</div>
          <div>產品名稱/編號/數量：{{item.size.way}}-{{item.style}}{{item.size.length}}{{item.size.unit}}{{item.size.weight}}錢 / {{item.productCode}} / {{item.amount}}個</div>
          <div>{{medals.includes(item.style)?"祝賀詞與名稱":"宮廟名"}}：{{item.text.templeName}}</div>
          <div>{{medals.includes(item.style)?"祝賀詞":"神明名"}}：{{item.text.godName}}</div>
          <div>贈送名/日期：{{item.text.gift}}</div>
          <div>{{medals.includes(item.style)?"贈詞":"敬獻詞"}}：{{item.text.respect}}</div>
        </div>
      </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "admin_print",
  data() {
    return {
      products: []
    };
  },
  created() {
    if (this.printInfo.id !== "") {
      this.getProduct();
    }
  },
  watch: {
    printInfo: {
      handler(newValue) {
        if (newValue.id !== "") {
          this.getProduct();
        }
      },
      deep: true
    },
    products: {
      handler() {
        if (typeof this.products !== "undefined") {
          //check img loading
          let checkNum = 0;
          this.products.forEach(item => {
            if (item.imageUrl.substring(0, 4) == "data") {
              checkNum = checkNum + 1;
            }
          });
          if (checkNum == this.products.length) {
            this.$store.dispatch("setPrintLoading", true);
            let printInfo = {
              id: "",
              productIndex: ""
            };
            this.$store.dispatch("setPrintInfo", printInfo);
          }
        }
      },
      deep: true
    }
  },
  methods: {
    getProduct() {
      let getPrintInfo = this.$store.getters.getPrintInfo;
      axios({
        url:
          this.$store.getters.getGlobalUrl +
          `admin/orders/${getPrintInfo.id}/items`,
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        }
      })
        .then(response => {
          if (getPrintInfo.productIndex == "all") {
            this.products = response.data.data;
          } else {
            let index = getPrintInfo.productIndex;
            this.products = [];
            this.products.push(response.data.data[index]);
          }
          this.products.forEach(item => {
            item.productCode = this.transformProductCode(item.size, item.style);
            item.size.way = this.$store.getters.getTransformWay(item.size.way);
            item.size.unit = this.$store.getters.getTransformUnit(
              item.size.unit
            );
          });
          this.baseToImg();
        })
        .catch(e => {
          alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
        });
    },
    baseToImg() {
      this.products.forEach(item => {
        axios({
          url: `${item.imageUrl}`,
          method: "get"
        })
          .then(response => {
            item.imageUrl = response.data;
          })
          .catch(e => {
            alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
          });
      });
    },
    transformProductCode(size, style) {
      let productCode = "";
      let way = "",
        code = "",
        length = "",
        weight = "";

      way = size.way;

      let styleSheet = this.$store.getters.customizeMetalData;
      styleSheet.forEach(item => {
        if (item.name == style) {
          code = item.code;
        }
      });

      if (isNaN(Math.floor(size.length))) {
        // 尺寸為 S,M 系列
        length = size.length.substr(0, 1);
      } else {
        length =
          size.unit == "cm"
            ? this.zeroFill(Math.floor(size.length).toString(), 3)
            : this.zeroFill(Math.floor(size.length * 3).toString(), 3);
      }

      weight = this.zeroFill(
        [...size.weight].filter(item => item !== ".").join(""),
        5
      );

      productCode = `${way}${code}-${length}-${weight}`;

      return productCode;
    },
    zeroFill(now, fillLength) {
      if (now.length < fillLength) {
        let fillNum = fillLength - now.length + 1;
        return new Array(fillNum).join("0").concat(now);
      }
      return now;
    }
  },
  computed: {
    printInfo() {
      return this.$store.getters.getPrintInfo;
    },
    medals() {
      return this.$store.getters.medalsLabelDisplayStyle;
    }
  }
};
</script>

<style scoped lang="scss">
* {
  font-size: 17px;
  color: $secondaryDeepColor1;
  box-sizing: border-box;
}
#admin-print {
  width: 100%;
}
#admin-print-container {
  display: flex;
  align-items: center;
  padding: 10px 10%;
  border-bottom: 1px solid $secondaryLightColor1;
}
.print-photo {
  // flex: 0 0 195px;
  height: 230px;
  padding: 0 15px;
  img {
    height: 100%;
  }
}
.print-text {
  padding: 0 15px;
  div {
    margin: 6px 0;
  }
}
@media print {
  #admin-print-container {
    // page-break-after: always;
    page-break-inside: avoid;
  }
}
</style>
